<template>
	<div class="card_matricula">
		<div class="card_matricula__welcome">
			<v-skeleton-loader
				v-if="loading"
				style="width:200px"
				:loading="loading"
				:transition="transition"
				height="94"
				type="list-item-two-line"
			></v-skeleton-loader>
			<div class="card_matricula__welcome__upper_text" v-if="!loading">
				¡Bienvenid{{ this.userDetail.gender == "M" ? "o" : "a" }}
				{{ userDetail.first_name }}!
			</div>
			<div class="card_matricula__welcome__lower_text" v-if="!loading">
				¿Qué deseas hacer?
			</div>
		</div>
		<div class="card_matricula__tabs_matricula">
			<v-tabs active-class="activo" grow v-model="tab">
				<v-tab class="tabs" :href="`#tab-1`">
					<v-skeleton-loader
						v-if="loading"
						style="width:40%"
						:loading="loading"
						:transition="transition"
						height="94"
						type="list-item"
					></v-skeleton-loader>
					<div v-if="!loading">
						Continuar
						<br />aprendiendo
					</div>
				</v-tab>
				<v-tab class="tabs" :href="`#tab-2`">
					<v-skeleton-loader
						v-if="loading"
						style="width:40%"
						:loading="loading"
						:transition="transition"
						height="94"
						type="list-item"
					></v-skeleton-loader>
					<div v-if="!loading">
						Aprender un
						<br />nuevo idioma
					</div>
				</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab" touchless>
				<v-tab-item :value="'tab-1'">
					<div class="content_learning" v-if="loading">
						<div
							class="content_taking_courses"
							v-for="(item, index) in 2"
							:key="index"
						>
							<div class="content_taking_section">
								<div class="content_responsive">
									<div class="left_content">
										<v-skeleton-loader
											style="width:107px"
											:loading="loading"
											:transition="transition"
											height="70"
											type="image"
										></v-skeleton-loader>
									</div>

									<div class="right_content">
										<div class="course_details_up">
											<div class="left_detail_up">
												<v-skeleton-loader
													style="width:100px;overflow:unset;"
													:loading="loading"
													:transition="transition"
													height="30"
													type="list-item"
												>
												</v-skeleton-loader>
												<div class="nivel_course">
													<v-skeleton-loader
														style="width:40px"
														:loading="loading"
														:transition="transition"
														height="50"
														type="list-item"
													></v-skeleton-loader>
													<v-skeleton-loader
														style="width:150px;margin-left:15px"
														:loading="loading"
														:transition="transition"
														height="50"
														type="list-item"
													></v-skeleton-loader>
												</div>
											</div>
											<div class="right_detailt_up">
												<v-skeleton-loader
													class="show_skeleton_button"
													style="width:280px;margin-left:15px"
													:loading="loading"
													:transition="transition"
													height="48"
													type="button"
												></v-skeleton-loader>
											</div>
										</div>
										<div class="course_details_down">
											<v-skeleton-loader
												style="width:55px"
												:loading="loading"
												:transition="transition"
												height="50"
												type="avatar"
											></v-skeleton-loader>

											<v-skeleton-loader
												style="width:100%;margin-left:15px"
												:loading="loading"
												:transition="transition"
												height="50"
												type="list-item"
											></v-skeleton-loader>
										</div>
									</div>
								</div>
								<div class="course_details_down2">
									<v-skeleton-loader
										style="width:55px"
										:loading="loading"
										:transition="transition"
										height="50"
										type="avatar"
									></v-skeleton-loader>

									<v-skeleton-loader
										style="width:100%;margin-left:15px"
										:loading="loading"
										:transition="transition"
										height="50"
										type="list-item"
									></v-skeleton-loader>
								</div>
								<v-skeleton-loader
									class="show_skeleton_button_mobile"
									style="width:100%"
									:loading="loading"
									:transition="transition"
									height="48"
									type="button"
								></v-skeleton-loader>
							</div>
						</div>
					</div>
					<div class="content_learning" v-if="!loading">
						<div
							class="learn_content"
							v-if="
								courseDetails.length == 0 ||
									courseDetails[0].status == statusCourse.statusCase5
							"
						>
							<span class="learn_text">
								Aquí encontrarás los cursos que hayas llevado con nosotros.
							</span>
						</div>
						<div
							class="content_taking_courses"
							v-for="item in courseDetails"
							:key="item.course_id"
						>
							<div
								class="content_taking_section"
								v-if="
									item.status != statusCourse.statusCase10 &&
										item.status != statusCourse.statusCase5
								"
							>
								<div class="content_responsive">
									<div class="left_content">
										<LanguageFlag
											:imageSource="item.language_id"
										></LanguageFlag>
									</div>
									<div class="right_content">
										<div class="course_details_up">
											<div class="left_detail_up">
												<div class="name_course">{{ item.language_name }}</div>
												<div class="nivel_course">
													<div
														class="nivel_course_left"
														v-if="item.course_code.length <= 4"
													>
														<span class="spacing">{{ item.course_code }}</span>
													</div>
													<div
														class="nivel_course_right"
														:style="
															item.course_code.length <= 4
																? ''
																: 'margin-left:0px'
														"
													>
														{{ item.course_name }}
													</div>
												</div>
											</div>

											<CheckEnrollment
												class="right_detailt_up"
												v-bind:course="item"
												typeStructure="desktop"
												@showPendingPay="showPendingPay"
												@status="statusValidate($event)"
											></CheckEnrollment>
										</div>
										<div class="course_details_down" v-if="item.message != ''">
											<v-icon
												v-bind:style="{
													color: item.message_icon_color,
												}"
												small
												>{{ item.message_icon }}</v-icon
											>
											<div class="left_down_text">
												{{ item.message }}
											</div>
										</div>
										<AccordionCourseDetail
											v-bind:items="item.course_detail"
											v-bind:typeStructure="`desktop`"
											v-if="item.course_detail && item.course_detail != null"
										></AccordionCourseDetail>
									</div>
								</div>

								<div class="course_details_down2" v-if="item.message != ''">
									<v-icon
										v-bind:style="{
											color: item.message_icon_color,
										}"
										small
										>{{ item.message_icon }}</v-icon
									>
									<div class="left_down_text2">
										{{ item.message }}
									</div>
								</div>

								<CheckEnrollment
									class="right_detailt_down"
									v-bind:course="item"
									typeStructure="mobile"
									@showPendingPay="showPendingPay"
									@status="statusValidate($event)"
								></CheckEnrollment>

								<AccordionCourseDetail
									v-bind:items="item.course_detail"
									v-bind:typeStructure="`mobile`"
									v-if="item.course_detail && item.course_detail != null"
								></AccordionCourseDetail>
							</div>
							<div
								class="content_taking_section"
								v-if="
									item.status != statusCourse.statusCase8 &&
										item.previous_course.length > 0 &&
										item.previous_course[0].status
								"
							>
								<div class="content_responsive">
									<div class="left_content">
										<LanguageFlag
											v-bind:imageSource="item.language_id"
										></LanguageFlag>
									</div>

									<div class="right_content">
										<div class="course_details_up">
											<div class="left_detail_up">
												<div class="name_course">{{ item.language_name }}</div>
												<div class="nivel_course">
													<div
														class="nivel_course_left"
														v-if="
															item.previous_course[0].course_code.length <= 4
														"
													>
														<span class="spacing">{{
															item.previous_course[0].course_code
														}}</span>
													</div>
													<div
														class="nivel_course_right"
														:style="
															item.previous_course[0].course_code.length <= 4
																? ''
																: 'margin-left: 0px'
														"
													>
														{{ item.previous_course[0].course_name }}
													</div>
												</div>
											</div>
											<div class="right_detailt_up">
												<div class="left_content_passed">
													<v-icon
														v-bind:style="{
															color: item.previous_course[0].status_color,
														}"
														large
														>{{ item.previous_course[0].status_icon }}</v-icon
													>

													<div class="passed_text">
														{{ item.previous_course[0].status }}:
														<span class="grade">{{
															item.previous_course[0].final_calification
																? item.previous_course[0].final_calification
																: "-"
														}}</span>
													</div>
												</div>
											</div>
										</div>
										<AccordionCourseDetail
											v-bind:items="item.previous_course[0]"
											v-bind:typeStructure="`desktop`"
										>
										</AccordionCourseDetail>
									</div>
								</div>
								<div class="left_content_passed2">
									<v-icon
										v-bind:style="{
											color: item.previous_course[0].status_color,
										}"
										large
									>
										{{ item.previous_course[0].status_icon }}
									</v-icon>

									<div class="passed_text">
										{{ item.previous_course[0].status }}:
										<span class="grade">{{
											item.previous_course[0].final_calification
												? item.previous_course[0].final_calification
												: "-"
										}}</span>
									</div>
								</div>
								<AccordionCourseDetail
									v-bind:items="item.previous_course[0]"
									v-bind:typeStructure="`mobile`"
								>
								</AccordionCourseDetail>
							</div>
						</div>
					</div>
					<!-- </v-skeleton-loader> -->
				</v-tab-item>
				<v-tab-item :value="'tab-2'" class="container__tabs">
					<select-language @status="statusValidate($event)"> </select-language>
				</v-tab-item>
			</v-tabs-items>
		</div>

		<v-dialog v-model="pendingPay" persistent max-width="600" max-height="95%">
			<v-card>
				<v-card-title class="titulo__dialog">
					<div class="flex-grow-1"></div>
					<v-btn icon @click="pendingPay = false" class="boton_close">
						<v-icon class="iconColor">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<div class="pending-pay-title-dialog pa-2">
					{{ userDetail.first_name }}, actualmente tienes un proceso de
					matrícula pendiente
				</div>
				<v-card-text class="pending-pay-description text-center mt-6 mb-1"
					>En la siguiente ventana podrás actualizar o permanecer con el medio
					de pago seleccionado para finalizar tu matrícula.
				</v-card-text>
				<v-card-text style="width: 90%;margin:auto">
					<form>
						<v-row>
							<v-col
								cols="12"
								xs="12"
								sm="12"
								md="12"
								style="display:flex;justify-content:center"
							>
								<button class="btn--primary" @click="pendingPay = false">
									Continuar
								</button>
							</v-col>

							<v-col cols="12" class="d-flex">
								<div class="icon_body">
									<v-icon color="primary" small>info</v-icon>
								</div>
								<div class="pending-pay-info ml-1">
									En caso desees modificar tu sección, horario o monto a pagar
									puedes realizarlo en el paso 1, anterior al pago.
								</div>
							</v-col>
						</v-row>
					</form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "../axios-auth";
import jwt from "jwt-simple";
import { mapState, mapMutations } from "vuex";
import AccordionCourseDetail from "@/components/AccordionCourseDetail.vue";
import LanguageFlag from "@/components/LanguageFlag.vue";
import CheckEnrollment from "@/components/CheckEnrollment.vue";
import SelectLanguage from "@/containers/languages/SelectLanguage";
export default {
	name: "principal",
	data: () => ({
		loading: true,
		loadingHeader: true,
		transition2: "scale-transition",
		transition: "scale-transition",
		userDetail: null,
		courseDetails: [],
		tab: null,
		statusCase: null,
		pendingPay: false,
		dataUsuarioMenor: null,
		user: null,
	}),
	components: {
		AccordionCourseDetail,
		LanguageFlag,
		CheckEnrollment,
		"select-language": SelectLanguage,
	},
	created() {
		this.setLanguage(null);
		this.setProgram(null);
		this.setRecognition(null);
		this.setScoreResult(null);
		this.setPostulation(null);
		this.userDetail = this.$store.state.usuario;
		this.loadingHeader = true;
		this.loadAcademicInformation();
		this.addPropToDefaultSection({ book: null });
		this.addPropToDefaultSection({ campus: null });
		this.addPropToDefaultSection({ campus_address: null });
		this.addPropToDefaultSection({ campus_name: null });
		this.addPropToDefaultSection({ classroom: null });
		this.addPropToDefaultSection({ course_amount: null });
		this.addPropToDefaultSection({ curriculum_id: null });
		this.addPropToDefaultSection({ expiration_date: null });
		this.addPropToDefaultSection({ frequency: null });
		this.addPropToDefaultSection({ modality_name: null });
		this.addPropToDefaultSection({ paymentType: null });
		this.addPropToDefaultSection({ schedule: null });
		this.addPropToDefaultSection({ section_id: null });
		this.addPropToDefaultSection({ start_end_date: null });
	},
	computed: {
		...mapState([
			"statusCourse",
			"statusModeButton",
			"statusModeText",
			"secretKeyJwt",
		]),
	},
	methods: {
		...mapMutations([
			"setLanguage",
			"setRecognition",
			"setScoreResult",
			"setProgram",
			"setPostulation",
			"addPropToDefaultSection",
		]),
		loadAcademicInformation() {
			let aux = "";
			if (this.userDetail.student_code) {
				aux = {
					student_code: this.userDetail.student_code
				};
			} else {
        aux = {
          username: this.userDetail.username
        };
      }
      axios
        .post(`users/academic-information/`, aux)
        .then(response => {
          this.courseDetails = response.data;
          this.loading = false;

          if (!this.courseDetails.length) {
            this.tab = "tab-2";
          }
        })
        .catch(err => {
          this.loading = false;
          this.$store.dispatch("salir");
        });
		},
		statusValidate(postulationStatus) {
			if (postulationStatus == "enrollment") {
				this.loadAcademicInformation();
				this.tab = "tab-1";
			}
		},

		showPendingPay() {
			this.pendingPay = true;
		},

		goToMatricula(item) {
			if (this.userDetail.has_debt || !item.button_enabled) {
				return;
			} else {
				if (localStorage.lastCourse) {
					localStorage.removeItem("lastCourse");
				}
				var secret = this.secretKeyJwt;
				var course = jwt.encode(item, secret);
				localStorage.setItem("lastCourse", course);
				this.$router.push("/enrollment/" + item.course_id);
			}
		},
		verifyLocked(enable) {
			if (this.userDetail.has_debt || !enable) {
				return "locked_button";
			} else return "";
		},
		verifyText(item) {
			if (item.status_mode === "Boton") {
				return item.button_text;
			} else {
				return item.text_message;
			}
		},
	},
	watch: {
		tab(value) {
			// console.log(value);
		},
	},
};
</script>

<style lang="scss">
// @import "./../assets/styles/todo";
// @import "./../assets/styles/responsiveness";
</style>
